import { memo } from 'react';
import { useNavigate } from 'react-router-dom';
import { clsx } from 'clsx';
import { Retailer, RetailerSettings } from '@/types';

export type PRetailer = Pick<
  Retailer,
  'id' | 'name' | 'colour' | 'logo' | 'description'
> & {
  settings: Pick<RetailerSettings, 'hideInvoices'>;
};

interface Props {
  retailers: PRetailer[];
  retailerId: string | undefined;
}

const RetailerContainer: React.FC<Props> = memo(({ retailers, retailerId }) => {
  const navigate = useNavigate();

  return (
    <div className="grid grid-cols-6 gap-1-6">
      {retailers.map((retailer) => (
        <div
          key={retailer?.id}
          className={clsx(
            retailerId == retailer?.id && 'bg-primary-blue text-white',
            'p-2-0 border border-secondary-grey rounded-8-0 w-full h-10-0 font-bd cursor-pointer',
          )}
          onClick={() => navigate(`/documents/${retailer?.id}/orders`)}
        >
          <p className="text-body1">{retailer?.name}</p>
        </div>
      ))}
    </div>
  );
});

export default RetailerContainer;
